// extracted by mini-css-extract-plugin
module.exports = {"plate":"Color_plate__2yzc0","gradual":"Color_gradual__1kk62","background":"Color_background__1tyVo","palette":"Color_palette__1IdXp"};